import React from 'react'
import Select from 'react-select'
import InfoButton from '../../InfoButton/InfoButton'

const CustomSearchableDropdown = ({ options, placeholder, onChange, className, isMulti, label, isimp, erroMessage, field, noOptionsMessage, noOptionsMessageClick, value, tooltip, defaultValue }) => {
    return (
        <div className={`customDropdownWrap flexbox false DropdownForm w100 ${erroMessage ? "dropdownHasError" : ""}`}>
            <label>
                {label} {isimp && <span className="impRed">*</span>} {tooltip ? <InfoButton tooltip={tooltip} /> : null}
            </label>

            <Select
                className={className}
                classNamePrefix="dropUpMenu"
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                menuPosition="fixed"
                styles={{
                    control: (base, state) => ({
                        ...base,
                        borderColor: erroMessage ? "#ef4444" : base.borderColor,
                        boxShadow: erroMessage
                            ? "0 0 0 3px rgba(239, 68, 68, 0.12)"
                            : base.boxShadow,
                        "&:hover": {
                            ...base["&:hover"],
                            borderColor: erroMessage ? "#ef4444" : base.borderColor,
                        },
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 1100,
                    }),
                    menu: (base) => ({
                        ...base,
                        zIndex: 1100,
                    }),
                }}
                defaultValue={defaultValue}
                onChange={(obj) => onChange(obj, field)}
                isMulti={isMulti}
                placeholder={placeholder}
                options={options}
                noOptionsMessage={() =>
                    <div onClick={() => { if (noOptionsMessageClick) { noOptionsMessageClick() } }}>{noOptionsMessage}</div>
                }
                value={value}
            />
            {erroMessage && (
                <span className={`FormError ${field === "categories" ? "categoriesDropdownError" : ""}`}>
                    {erroMessage}
                </span>
            )}
        </div>
    )
}

export default CustomSearchableDropdown
